<template>
  <default-view ref="default">

    <template slot="header">
      Plate: {{plate.name}}

      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-icon v-on="on" style="margin-left: 8px;">
            mdi-cog
          </v-icon>
        </template>
        <template #default>
          <pre>{{ JSON.stringify(state, null, 2) }}</pre>
        </template>
      </v-tooltip>
    </template>

    <template slot="toolbar-items">

      <v-tooltip bottom open-delay="600ms">
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on"
                 @click=" show_dlgPlateProps=true " :disabled="is_plate">
            <v-icon>mdi-file-document-edit-outline</v-icon>
          </v-btn>
        </template>

        <span> Plate properties edit dialog </span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Read/process plate data file -->
      <v-tooltip bottom open-delay="600ms">
        <template v-slot:activator="{ on }">
          <v-btn ref="btnProcessFile" icon v-on="on"
                 @click="btnProcessFile_click" :disabled="is_plate">
            <v-icon>data_usage</v-icon>
          </v-btn>
        </template>
        <span> Proccess plate data file </span>
      </v-tooltip>

      <!-- Process spectra data to probes -->
      <v-tooltip bottom open-delay="600ms">

        <template #activator="{ on }">
          <v-btn ref="btnProcessProbes" icon v-on="on"
                 @click="btnProcessProbes_click" :disabled="is_plate">
            <v-icon>mdi-air-filter</v-icon>
          </v-btn>
        </template>
        <span> Process spectra data to probes </span>
      </v-tooltip>

      <!-- Calc background -->
      <v-tooltip bottom open-delay="600ms">
        <template #activator="{ on }">
          <v-btn ref="btnCalcBg" icon v-on="on"
                 @click="btnCalcBg_click" :disabled="is_plate">
            <v-icon>mdi-chart-sankey-variant mdi-flip-v</v-icon>
          </v-btn>
        </template>
        <span>Calc background of probes signals</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Reload plate data -->
      <v-tooltip bottom open-delay="600ms">

        <template v-slot:activator="{ on }">
          <v-btn ref="btnReload" icon @click.native="btnReload_click($event)" v-on="on">
            <v-icon>refresh</v-icon>
          </v-btn>
        </template>

        <span> Reload plate data </span>

      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Probe plex probe set spectra source  -->
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-btn
            icon v-on="on" :disabled=" selected_wells.length === 0 "
            @click="btnPppSource_click">
            <v-icon>mdi-chart-timeline-variant-shimmer</v-icon>
          </v-btn>
        </template>
      </v-tooltip>

      <v-spacer></v-spacer>

      <!-- Development toolbox -->
      <v-menu bottom right offset-y z-index="200"
              :close-on-content-click="true">
        <template #activator="{ on:onMenu }">

          <v-tooltip bottom>
            <template #activator="{ on:onTooltip }">
              <v-btn icon v-on="{ ...onMenu, ...onTooltip }">
                <v-icon>mdi-toolbox-outline</v-icon>
              </v-btn>
            </template>
            <span>Development toolbox</span>
          </v-tooltip>

        </template>

        <v-list>
          <v-list-item-group>

            <v-list-item @click="btnPurgeWellData_click">
              <v-list-item-action>
                <v-icon>mdi-delete-sweep-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                Purge well data loaded
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-action>
                <v-icon>mdi-ghost-outline</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                Other tool
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>


      </v-menu>

    </template>

    <template slot="content" style="height:100%; overflow-y: scroll;">
      <v-layout row fill-hight style="padding-left: 24px; padding-right: 24px;">

        <!-- основная строка -->
        <v-flex xs12 sm12 md12 lg12 xl12>

          <v-layout fluid>

            <!-- charts -->
            <v-flex style="width: 30%;" grow>

              <span>Views:</span>
              <span>
              active={{tabs.active}}; raw={{tabs.raw}}, probes={{tabs.probes}}, targets={{tabs.targets}}
            </span>

              <v-tabs v-model="tabs.active" grow>

                <!-- RAW -->
                <v-tooltip bottom open-delay="600">
                  <template v-slot:activator="{ on }">
                    <v-tab v-on="on" :key="tabs.raw">
                      Raw
                    </v-tab>
                  </template>
                  <span>Raw spectral data</span>
                </v-tooltip>
                <v-tab-item :key="tabs.raw">
                  <!-- raw data -->
                  <plate-raw ref="ctrlPlateRaw" :disabled="tabs.active !== tabs.raw"
                             :plate="plate" :selected_wells="selected_wells"
                             :hovered_well="hovered_well_num">
                  </plate-raw>
                </v-tab-item>

                <!-- PROBES -->
                <v-tooltip bottom open-delay="600">
                  <template v-slot:activator="{ on }">
                    <v-tab v-on="on" :key="tabs.probes">
                      Probes
                    </v-tab>
                  </template>
                  <span>Probes' data</span>
                </v-tooltip>
                <v-tab-item :key="tabs.probes">
                  <!-- probe data -->
                  <plate-probe ref="ctrlPlateProbe" :disabled="tabs.active !== tabs.probes"
                               :plate="plate" :selected_wells="selected_wells"
                               @selected_probes="ctrlPlateProbe_selectedProbes"
                               :hovered_well="hovered_well_num">
                  </plate-probe>
                </v-tab-item>

                <!-- TARGETS -->
                <v-tooltip bottom open-delay="600">
                  <template v-slot:activator="{ on }">
                    <v-tab v-on="on" :key="tabs.targets">
                      Targets
                    </v-tab>
                  </template>
                  <span>Analyzed qPCR data</span>
                </v-tooltip>
                <v-tab-item :key="tabs.targets">
                  <!-- probe data with background substracted -->
                  <plate-target ref="ctrlPlateTarget" :disabled="tabs.active !== tabs.targets"
                                :plate="plate" :selected_wells="selected_wells">
                  </plate-target>
                </v-tab-item>

                <!-- WELLS -->
                <v-tooltip bottom open-delay="600">
                  <template v-slot:activator="{ on }">
                    <v-tab v-on="on" :key="tabs.wells">
                      Wells
                    </v-tab>
                  </template>
                  <span>Wells' properties</span>
                </v-tooltip>
                <v-tab-item :key="tabs.wells">

                </v-tab-item>

              </v-tabs>

              Samples:
              <v-item-group v-model="selected_samples" multiple>
                <v-layout row justify-space-around center>
                  <template v-for="sample in sample_items">
                    <v-item :key="sample.id" :value="sample.id"
                            v-slot:default="{ active, toggle }">
                      <v-tooltip top open-delay="600ms">
                        <template v-slot:activator="{ on }">
                          <v-scroll-y-transition>
                            <v-chip v-if="!active" v-on="on" @click="toggle"
                                    style="padding: 5px 12px 5px 12px; margin: 2px;" outlined>
                              {{ sample.name }}
                            </v-chip>

                            <v-chip v-if="active" v-on="on" @click="toggle"
                                    style="color: white; background-color: #444444; padding: 6px 13px 6px 13px; margin: 2px;">
                              {{ sample.name }}
                            </v-chip>
                          </v-scroll-y-transition>
                        </template>
                      </v-tooltip>
                    </v-item>
                  </template>
                </v-layout>
              </v-item-group>


            </v-flex>

            <!-- wells -->
            <v-flex style="width:529px;" shrink>

              <span>right</span>
              <plate-96 ref="hotPlate" :plate="plate"
                        :selected_wells="selected_wells"
                        @selected="hotPlate_selected"
                        @hovered="hotPlate_hovered">
              </plate-96>
              <!--            <div>{{selected_wells}}</div>-->

              <!-- ----  -->
              <wells-props ref="ctrlPlateWellsProps"
                           :plate="plate"
                           :selected_wells="selected_wells"
                           :selected_probes="selected_probes"
                           @apply="ctrlPlateWellsProps_apply">
              </wells-props>

              <div>
                <div>Hovered well #{{hovered_well_num}}</div>
                <!--              <div>-->
                <!--                {{ hovered_well.probe_data_bg }}-->
                <!--              </div>-->

                <!--              <div v-for="probe in hovered_well.probe_data_bg" :key="probe.id">-->

                <!--              </div>-->
              </div>

            </v-flex>

          </v-layout>

        </v-flex>

        <!-- нижняя строка -->
        <v-flex xs12 sm12 md12 lg12 xl12 style="background-color: #fcedd9;">

          <v-layout row justify-space-around center>
            <v-flex fuild>
              <span>Second row</span>
            </v-flex>
          </v-layout>

        </v-flex>

      </v-layout>
    </template>

    <plate-props-dialog
      ref="dlgPlateProps" slot="content"
      :value="show_dlgPlateProps" @closing="dlgPlateProps_closing"
      :plate="plate" :new="false"
      @accepted="dlgPlateProps_accepted"
    ></plate-props-dialog>

    <probe-plex-probe-source-dialog
      ref="dlgPppSource" slot="content"
      :value="show_dlgPppSource" @closing="dlgPppSource_closing"
      :plate="plate"
      :selected_wells="selected_wells"
      @accepted="dlgPppSource_accepted"
    ></probe-plex-probe-source-dialog>

  </default-view>
</template>

<script>

	import {mdiAirFilter} from '@mdi/js'
	import {mdiFileDocumentEditOutline} from '@mdi/js'
	import {mdiChartBellCurveCumulative} from '@mdi/js'

	import api from '../../api'
	import format from 'string-format'
	import {mapActions, mapGetters} from 'vuex'
	import {Plate} from '../../models'
	import {
		VContainer, VLayout, VRow, VCol,
		VBtn
	} from 'vuetify'
	// import VueSplitter, {VueSplitterV, VueSplitterH} from 'vue-splitter-pane'

	// import {
	// 	TiptapVuetify,
	// 	Heading, Bold, Italic, Strike, Underline, Code, Paragraph,
	// 	BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak,
	// 	HorizontalRule, History
	// } from 'tiptap-vuetify'

	import Plate96Component from '../../components/plate/Plate96Component'
	import DefaultView from "../app/DefaultView"
	import PlatePropsDialog from "../../components/plate/PlatePropsDialog"

	import PlateRawComponent from '../../components/plate/PlateRawComponent'
	import PlateProbeComponent from '../../components/plate/PlateProbeComponent'
	import PlateTargetComponent from "../../components/plate/PlateTargetComponent"

	import WellsPropsComponent from "../../components/plate/WellsPropsComponent"
	import WellListComponent from "../../components/plate/WellListComponent"
	import ProbePlexProbeSourceDialog from "../../components/ProbePlex/ProbePlexProbeSourceDialog"


	export default {
		name: "plate-view",

		components: {
			ProbePlexProbeSourceDialog,
			DefaultView,
			// VueSplitter, VueSplitterV, VueSplitterH,
			VContainer, VLayout, VRow, VCol,
			VBtn,
			PlatePropsDialog,
			'plate-96': Plate96Component,
			'plate-raw': PlateRawComponent,
			'plate-probe': PlateProbeComponent,
			'plate-target': PlateTargetComponent,

			'wells-props': WellsPropsComponent,
			'well-list': WellListComponent,

			// TiptapVuetify,
			// Heading, Bold, Italic, Strike, Underline, Code,
			// BulletList, OrderedList, ListItem, Link, History
		},

		data: function () {
			return {
				// plate: Plate.empty_plate,

				tabs: {
					active: 1,
					raw: 0,
					probes: 1,
					targets: 2,
					wells: 3
				},

				show_dlgPlateProps: false,
				show_dlgPppSource: false,

				selected_wells: [],
				selected_probes: [],
				hovered_well_num: -1,
				hovered_well: null,

				plate_wells: [],

				selected_samples: [],

				extensions: [
					// Heading,
					// Bold
					// Bold, Italic, Strike, Underline, Code,
					// BulletList, OrderedList, ListItem, Link, History
				],
				text: "Привет"
			}
		},

		computed: {
			plate_id: function () {
				return this.$route.query.id
			},

			is_plate: function () {
				return this.plate === Plate.empty_plate
			},

			sample_items: function () {
				return Object.values(this.plate.samples)
					.sort(function (s1, s2) {
						return s1.name < s2.name
							? -1
							: s1.name > s2.name
								? 1
								: 0
					})
			},

			...mapGetters({
				message_list: 'message/list',
				plate: 'plate/plate'
			}),

			state: function () {
				return {
					selected_wells: this.selected_wells,
					plate: {
						points_len: this.plate.points_len,
						filtersets_len: this.plate.filtersets_len,
						// 'points.length': this.plate.points.length,
						// 'filtersets.length': this.plate.filtersets.length,
					},
				}
			},
		},

		watch: {

			plate: function (new_value, old_value) {
				console.debug("PlateView.watch.plate()")
				let k = 7
			},

			selected_wells: function (value) {
				console.debug("PlateView.watch.selected_wells()")

				this.plate_wells = {
					plate: {
						id: this.plate.id,
						name: this.plate.name
					},
					well_num_list: this.selected_wells,
				}
			},

			hovered_well_num: function (value) {
				this.hovered_well = this.plate.wells[this.hovered_well_num]
			},

			selected_samples: function (new_selected_samples) {
				const new_selected_well_nums = []
				for (let well_num in this.plate.wells) {
					const sample_id = this.plate.wells[well_num].sample.id
					if (new_selected_samples.includes(sample_id)) {
						new_selected_well_nums.push(well_num)
					}
				}
				console.debug(format(
					"PlateView.watch.selected_samples( {0} ) -> wells: {1}",
					new_selected_samples, new_selected_well_nums))

				this.selected_wells = new_selected_well_nums
			},

			// -- dialogs --
			showPlatePropsDialog: function (value) {
				console.debug(format("watch: PlateView.show_dlgPlateProps(value={0})", value))
				//this.dlgPlateProps.show()
			},

			'tabs.active': function () {
				console.debug(format("PlateView.watch.tabs.active( {0})", this.tabs.active))
			}
		},

		created() {
			console.debug("PlateView.created() ")

			this.load_data()
		},

		methods: {
			...mapActions({
				plate_update_plate: 'plate/update_plate',
				probePlex_ppp_update_spectra_source: 'probePlex/ppp_update_spectra_source',


				message_add: 'message/add',
				progress_begin: 'progress/begin',
				progress_end: 'progress/end',
			}),

			load_data: function () {
				console.debug("PlateView.load_data()")

				if (!this.plate_id) {
					//
					console.error("PlateView.load_data() no plate_id specified")
				}

				const me = this
				this.progress_begin({message: "Loading plate ..."})
				return this.$root.$children[0].lists_promise
					.then(function () {
						console.debug("PlateView.load_data.lists_promise.then()")

						// обновление поля plate (см. mapGetters) придет из store по реактивности
						return me.$store.dispatch('plate/fetchPlate', {plate_id: me.plate_id})
							.catch(function (error) {
								me.message_add(error)
							})
							.finally(function () {
								me.progress_end()
							})
					})
				//  Loading lists errors are handling with dispatch() call in DefaultView
			},

			update_plate: function (plate) {
				this.progress_begin({message: "Updating plate ..."})
				return this.plate_update_plate({plate, details: true})
					.then(() => this.message_add({type: 'success', html: "Plate updated."}))
					.catch((error) => this.message_add(error))
					.finally(() => this.progress_end())
			},

			// -- Handle controls' events --

			hotPlate_selected: function (selected_wells) {
				// console.debug(format(
				// 	"PlateView.hotPlate_selected(selected={0}) ", selected))
				this.selected_wells = selected_wells
			},

			hotPlate_hovered: function (hovered) {
				// console.debug(format("PlateView.hotPlate_hovered( #{0} )", hovered))
				this.hovered_well_num = hovered
			},

			ctrlPlateProbe_selectedProbes: function (selected_probes) {
				this.selected_probes = selected_probes
			},

			btnPppSource_click: function () {
				this.plate_wells = this.selected_wells
				this.show_dlgPppSource = true
			},

			// -- Handle dlgPlateProps events --

			dlgPlateProps_error: function (error) {
				console.error(format(
					"PlateView.dlgPlateProps_error() {error}",
					{error: error}))
			},

			dlgPlateProps_accepted: function (event) {
				event.result(this.update_plate(event.inputs))
			},

			dlgPlateProps_closing: function (event) {
				this.show_dlgPlateProps = false
			},

			dlgPlateProps_closed: function () {
				console.debug("PlateView.dlgPlateProps_closed() ")
			},

			// -- Handle dlgPppSource events --

			dlgPppSource_accepted: function (event) {
				console.debug("PlateView.dlgPppSource_accepted()")
				this.progress_begin(
					{message: 'Update probe plex probe spectra source...',})

				const ppp = event.inputs.ppp
				const plate_wells = event.inputs.plate_wells

				this.probePlex_ppp_update_spectra_source({ppp, plate_wells})
					.then(() => {
						event.result(true)
					})
					.catch((error) => this.message_add(error))
					.then(() => {
						this.progress_end()
					})
			},

			dlgPppSource_closing: function (event) {
				console.debug("PlateView.dlgPppSource_closing() ")
				this.show_dlgPppSource = false
			},

			// -- Handle buttons --

			btnProcessFile_click: function (event) {
				console.debug("PlateView.btnProcessFile_click() ")

				const me = this
				me.progress_begin({message: "Processing plate data file ..."})
				api.plate.plate_process_file(this.plate.id)
					.then(function (response) {
						// перезагрузим справочники, так как при обработке
						// файла данных планшеты могли появиться новые образцы и зонды
						return me.$root.$children[0].load_lists()
							.then(function () {
								me.message_add({type: 'success', html: "Plate data file processed."})
								return me.load_data()
							})
					})
					.catch(function (error) {
						me.message_add(error)
					})
					.finally(function () {
						me.progress_end()
					})
			},

			btnProcessProbes_click: function () {
				console.debug("PlateView.btnProcessProbe_click() ")

				const me = this
				me.progress_begin({message: "Processing spectra to probes ..."})

				api.plate.plate_process_spectra(this.plate.id)
					.then(function (response) {
						return me.load_data()
					})
					.catch(function (error) {
						me.message_add(error)
					})
					.finally(function () {
						me.message_add({type: 'success', html: "Plate well spectra process to probe signal"})
						me.progress_end()
					})
			},

			btnCalcBg_click: function () {
				console.debug("PlateView.btnCalcBg_click()")

				const me = this
				me.progress_begin({message: "Calc background ... "})

				Promise.all([
					// выбрасываем данные зондов в лунках
					me.$store.dispatch('plate/purge_well_data'),
					api.plate.plate_calc_background(this.plate.id)
				])
					.then(function ([purge_result, substract_response]) {
						// при расчете фона данные планшеты не меняются,
						// только данные зондов в лунках, их сбрасываем выше
						// me.load_data()
						const well_count = substract_response.data.well_count
						me.message_add({
							type: well_count > 0 ? 'success' : 'warning',
							html: format("{0} wells probes background substracted", well_count)
						})
					})
					.catch(function (error) {
						me.message_add(error)
					})
					.finally(function () {
						me.progress_end()
					})
			},

			btnReload_click: function (event) {
				console.debug("PlateView.btnReload_click() ")
				this.load_data()
			},

			btnPurgeWellData_click: function (event) {
				console.debug("PlateView.btnPurgeWellData_click()")

				const me = this
				me.$store.dispatch('plate/purge_well_data')
					.then(function (result) {
						me.message_add({type: 'success', html: "Probe data purged of current plate"})
					})
					.catch(function (error) {
						me.message_add(error)
					})
			},

			ctrlPlateWellsProps_apply(e) {
				if (this.selected_wells.length === 1) {
					const well_num = this.selected_wells[0]
					this.selected_wells = [(well_num + 1) % this.plate.plate_frame.count]
				}
			},
		},

	}

</script>

<style scoped>

</style>